import type { CurrentUserSearchCriteria } from "@/modules/user/api/types"

import { useQuery } from "@tanstack/react-query"

import {
  DEFAULT_QUERY_CACHE_TIME as QUERY_CACHE_TIME,
  DEFAULT_QUERY_STALE_TIME as QUERY_STALE_TIME,
} from "@/modules/api/constants"
import { CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY } from "@/modules/user/api/constants"
import { getCurrentUserSearchCriteria } from "@/modules/user/api/getCurrentUserSearchCriteria"
import { getCurrentUserSearchCriteriaKeys } from "@/modules/user/api/getUserQueryKeys"
import { useCurrentUserFetch } from "@/modules/user/client/hooks/useCurrentUserFetch"

type UseCurrentUserSearchCriteriaFetch = {
  dataCurrentUserSearchCriteria?: CurrentUserSearchCriteria
  isErrorCurrentUserSearchCriteria: boolean
  isLoadingCurrentUserSearchCriteria: boolean
  isSuccessCurrentUserSearchCriteria: boolean
}

export const useCurrentUserSearchCriteriaFetch = (): UseCurrentUserSearchCriteriaFetch => {
  const { dataCurrentUser } = useCurrentUserFetch()
  const isLogged = !!dataCurrentUser?.isLogged

  const {
    data: dataCurrentUserSearchCriteria,
    isError: isErrorCurrentUserSearchCriteria,
    isPending: isLoadingCurrentUserSearchCriteria,
    isSuccess: isSuccessCurrentUserSearchCriteria,
  } = useQuery({
    enabled: !!isLogged && !!dataCurrentUser.attributes.isStudent,
    gcTime: QUERY_CACHE_TIME,
    queryFn: () => getCurrentUserSearchCriteria({}),

    queryKey: getCurrentUserSearchCriteriaKeys({ isLogged, queryKey: CURRENT_USER_SEARCH_CRITERIA_QUERY_KEY }),
    staleTime: QUERY_STALE_TIME,
  })

  return {
    dataCurrentUserSearchCriteria,
    isErrorCurrentUserSearchCriteria,
    isLoadingCurrentUserSearchCriteria,
    isSuccessCurrentUserSearchCriteria,
  }
}
